import { Injectable } from '@angular/core';
import { EntityState, EntityStore, StoreConfig } from '@datorama/akita';

import { Borrower } from '../../models/loan-application.model';

export interface BorrowersState extends EntityState<Borrower, number> {
  borrowerID: number;
}

function createInitialState(): Borrower {
  return <Borrower>{};
}

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'docutech-borrowers-store', idKey: 'borrowerID' })
export class BorrowersStore extends EntityStore<BorrowersState> {
  constructor() {
    super(createInitialState());
  }
}
